import client from './client';

import { Question, QuestionCreate, QuestionUpdate } from './questionnaire.types';

// =============================================================================
// API Functions - Question Management (Admin)
// =============================================================================

export async function createQuestion(
  questionnaireId: number,
  data: QuestionCreate,
): Promise<Question> {
  const response = await client.post<Question>(
    `/questionnaires/${questionnaireId}/questions`,
    data,
  );
  return response.data;
}

export async function updateQuestion(
  questionnaireId: number,
  questionId: number,
  data: QuestionUpdate,
): Promise<Question> {
  const response = await client.put<Question>(
    `/questionnaires/${questionnaireId}/questions/${questionId}`,
    data,
  );
  return response.data;
}

export async function deleteQuestion(
  questionnaireId: number,
  questionId: number,
): Promise<void> {
  await client.delete(
    `/questionnaires/${questionnaireId}/questions/${questionId}`,
  );
}

export async function reorderQuestions(
  questionnaireId: number,
  questionIds: number[],
): Promise<void> {
  await client.put(
    `/questionnaires/${questionnaireId}/questions/reorder`,
    { questionIds },
  );
}
